import axios from "axios";
import { apiConstants } from "../utils/apiConstants";
import { endTrackedSessionOnPageExit } from "../utils/sessionManager";
let navigate;

export const setNavigate = (nav) => {
  navigate = nav;
};

const axiosInstance = axios.create({
  baseURL: apiConstants.BASE_URL_1,
  // headers: {
  //   get: {
  //     AuthenticationToken: localStorage.getItem("token"),
  //     TenantSlugName: localStorage.getItem("tenantName"),
  //   },
  // },
});

axiosInstance.interceptors.response.use(
  function (response) {
    return Promise.resolve(response);
  },
  function (error) {
    if (error.response) {
      if (error?.config?.url === apiConstants.LOGIN.LOGIN2) {
        return Promise.reject(error.response);
      }
      // if (error.response.status === 401 || error.response.status === 403) {
      //   let tenantName = localStorage.getItem("tenantName");
      //   let securityProviderName = localStorage.getItem("SecurityProviderName");
      //   window.location.href =
      //     securityProviderName === "aad"
      //       ? "/"
      //       : tenantName
      //       ? `/${tenantName}/login`
      //       : "/";
      // }
      if (error.response.status === 401) {
        let tenantName = localStorage.getItem("tenantName");
        let securityProviderName = localStorage.getItem("SecurityProviderName");
        endTrackedSessionOnPageExit();
        localStorage.clear();
        sessionStorage.clear();
        window.location.href =
          securityProviderName === "aad"
            ? "/"
            : tenantName
            ? `/${tenantName}/login`
            : "/";
      }
      if (error.response.status === 403) {
        let tenantName = localStorage.getItem("tenantName");
        let securityProviderName = localStorage.getItem("SecurityProviderName");
        navigate(
          securityProviderName === "aad"
            ? "/"
            : tenantName
            ? `/${tenantName}/access-denied`
            : "/"
        );
      }
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
